import { serverURL } from "../utils";

let headers = {
  "Content-Type": "application/json",
};

export const changePassword = (user) => {
  const data = {
    client_id: process.env.REACT_APP_AUTH0_CLIENTID,
    email: user.email,
    connection: "Username-Password-Authentication",
  };
  fetch(`https://${process.env.REACT_APP_AUTH0_DOMAIN}/dbconnections/change_password`, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  });
};

export const supportRequest = async (supportObj) => {
  const response = await fetch(`${serverURL()}/support`, {
    method: "POST",
    headers,
    body: JSON.stringify(supportObj),
  });
  return response;
};

export const dataRequest = async (supportObj) => {
  const response = await fetch(`${serverURL()}/support/data-request`, {
    method: "POST",
    headers,
    body: JSON.stringify(supportObj),
  });
  return response;
};
